import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import jsPDF from 'jspdf';
import { Parser } from 'json2csv';
import { saveAs } from 'file-saver';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

import useSortInfo from '../../Hooks/useSortInfo';
import useFilteredRows from '../../Hooks/useFilteredRows';
import useRowSelection from '../../Hooks/useRowSelection';
import useRowExpansion from '../../Hooks/useRowExpansion';
import useSortedRows from '../../Hooks/useSortedRows';
import ReactSelect from 'react-select';
import Option, { statusOptions } from './ReactMultiSelect';

import doesRowMatchSearchString from '../../Utils/doesRowMatchSearchString';

import './InventoryDataTable.css';

import {
	Button,
	Dropdown,
	Search,
	DataTable,
	OverflowMenu,
	OverflowMenuItem,
	Icon,
	TooltipIcon,
	Table,
	TableBatchAction,
	TableBatchActions,
	TableBody,
	TableCell,
	TableContainer,
	TableExpandHeader,
	TableExpandRow,
	TableExpandedRow,
	TableHead,
	TableHeader,
	TableRow,
	TableSelectAll,
	TableSelectRow,
	TableToolbar,
	TableToolbarAction,
	TableToolbarContent,
	TableToolbarSearch,
	TableToolbarMenu,
	MultiSelect,
} from 'carbon-components-react';

import { Img } from 'react-image';

import {
	RequestQuote20,
	Download20,
	Delete20,
	Renew20,
	Search20,
	CircleDash20,
	EventSchedule20,
	Category20,
	ArrowRight20,
	Redo20,
	Add20,
} from '@carbon/icons-react';

// TODO, REFACTOR
// TODO optimize performance

function InventoryTable(props) {
	const urlParams = window.location.search.substr(1, window.location.search.length);
	let addMode = false;
	let editMode = false;
	if (urlParams === 'mode=add') {
		addMode = true;
	} else if (urlParams === 'mode=edit') {
		editMode = true;
	}

	//set history
	const history = useHistory();

	//get props
	const { inventoryData, loading, refreshData, quoteItems, setQuoteItems, quoteToEdit, setQuoteToEdit, propSortInfo, collator } = props;

	//define state
	const [pageSize, setPageSize] = useState(2000);
	const [dataDisplay, setDataDisplay] = useState(inventoryData);
	const [inputString, setInputString] = useState('');
	const [searching, setSearching] = useState(false);
	const [searchingCat, setSearchingCat] = useState(false);
	const [searchingStatus, setSearchingStatus] = useState(false);

	//table constants and hooks
	const [sortInfo, setSortInfo] = useSortInfo(propSortInfo);
	const [filteredRows, searchString, setSearchString, categoryString, setCategoryString, statusString, setStatusString, setStatusArray, statusArray] =
		useFilteredRows(inventoryData, dataDisplay, setQuoteItems);
	const [setRowExpansion] = useRowExpansion(filteredRows, searchString, setDataDisplay);
	const [setRowSelection] = useRowSelection(filteredRows, searchString, setDataDisplay);

	const [sortedRows] = useSortedRows(filteredRows, sortInfo, collator);
	const hasSelection = true;
	const start = 0;
	const elementId = uuidv4();
	const selectedRowsCountInFiltered = filteredRows.filter((row) => row.selected).length;
	const selectedAllInFiltered = selectedRowsCountInFiltered > 0 && filteredRows.length === selectedRowsCountInFiltered;
	const hasBatchActions = hasSelection && selectedRowsCountInFiltered > 0;
	const { columnId: sortColumnId, direction: sortDirection } = sortInfo;
	const selectionAllName = !hasSelection ? undefined : `__custom-data-table_select-all_${elementId}`;
	const textInputSearch = useRef(null);

	//USE EFFECT & LIFECYCLE FUNCTIONS ---------------------------

	useEffect(() => {}, [quoteToEdit]);

	// FUNCTIONS -----------------------------

	const handleChangeExpansion = useCallback((event, expanded) => {
		const { currentTarget } = event;
		const row = currentTarget.closest('tr');
		if (row) {
			setRowExpansion(Number(row.dataset.rowId), !expanded);
		}
	});

	const handleCancelSelection = useCallback(() => {
		setRowSelection(undefined, false);
	}, [setRowSelection]);

	const handleChangeSelection = useCallback(
		(event) => {
			const { currentTarget } = event;
			const row = currentTarget.closest('tr');
			if (row) {
				setRowSelection(Number(row.dataset.rowId), currentTarget.checked);
			}
		},
		[setRowSelection]
	);

	const handleChangeSelectionAll = useCallback(
		(event) => {
			setRowSelection(undefined, event.currentTarget.checked, true);
		},
		[setRowSelection]
	);

	const handleChangeSort = useCallback(
		(event) => {
			const { currentTarget } = event;
			const { columnId, sortCycle, sortDirection: oldDirection } = currentTarget.dataset;
			setSortInfo({ columnId, sortCycle, oldDirection });
		},
		[setSortInfo]
	);

	const handleDeleteRows = useCallback(() => {
		setDataDisplay(dataDisplay.filter((row) => !row.selected || !doesRowMatchSearchString(row, searchString)));
	}, [dataDisplay, searchString]);

	// const handleChangePageSize = useCallback(
	//   ({ pageSize }) => {
	//     setPageSize(pageSize);
	//   },
	//   [setPageSize]
	// );

	// const handleChangeStart = useCallback(
	//   ({ start }) => {
	//     setStart(start);
	//   },
	//   [setStart]
	// );

	const _handleCreateQuote = () => {
		const itemsSelected = filteredRows.filter((row) => row.selected);

		if (editMode) {
			if (!quoteToEdit) {
				alert('Error, please go back to the quote edit page');
				return;
			}
			let quoteToEditClone = { ...quoteToEdit };
			console.log('quoteToEditClone', quoteToEditClone);
			let allTheItems = quoteToEditClone.items.concat(itemsSelected);
			quoteToEditClone.items = allTheItems;
			console.log('new quotetoedit', quoteToEditClone);
			setQuoteToEdit(quoteToEditClone);
			return history.goBack();
		}

		let quoteItemsClone = quoteItems;
		itemsSelected.map((sItem, i) => {
			quoteItems.map((qItem, i) => {
				console.log(qItem.id, sItem.id);
				if (qItem.id === sItem.id) {
					quoteItemsClone.splice(i, 1);
				}
			});
		});

		const newQuoteItems = itemsSelected.concat(quoteItemsClone);

		setQuoteItems(newQuoteItems);
		history.push('/quote-creator');
	};

	const _handleDownloadSelectedItems = () => {
		const itemsSelected = filteredRows.filter((row) => row.selected);

		// let cleanedItemsSelected = itemsSelected.map( (item) => {
		//
		// })

		let renamedQuoteItems = itemsSelected.map((item, i) => {
			let modifiedItem = {};
			Object.keys(item).map((key) => {
				if (key === 'itemNumber') {
					modifiedItem['Item Number'] = item[key];
				}
				if (key === 'upc') {
					modifiedItem['UPC'] = item[key];
				}
				if (key === 'description') {
					modifiedItem['Description'] = item[key];
				}
				if (key === 'packSize') {
					modifiedItem['Case Pack'] = item[key];
				}
				if (key === 'sellUOM') {
					modifiedItem['Selling Unit of Measure'] = item[key];
				}
				if (key === 'expireDate') {
					modifiedItem['Expiration Date'] = item[key];
				}
				if (key === 'fOBCost') {
					modifiedItem['FOB Smallest Cost'] = item[key];
				}
				if (key === 'estimatedShipDate') {
					modifiedItem['Estimated Ship Date'] = item[key];
				}
				if (key === 'units') {
					modifiedItem['Units'] = item[key];
				}
			});

			return modifiedItem;
		});

		// cwc _ items _ date time
		const fileName = `CWC_Selected_Items_${new Date().toString().substr(0, 15)}.csv`.replace(/ /g, '-');

		const fields = [
			'Item Number',
			'UPC',
			'Description',
			'Case Pack',
			'Selling Unit of Measure',
			'Expiration Date',
			'FOB Smallest Cost',
			'Estimated Ship Date',
			'Units',
		];
		const json2csvParser = new Parser({ fields });
		const csvFile = json2csvParser.parse(renamedQuoteItems);

		var csvblob = new Blob([csvFile], { type: 'text/csv;charset=utf-8' });
		saveAs(csvblob, fileName);

		return;
	};

	const _handleResetSearch = (e) => {
		const theInput = e.target.value;
		if (theInput === '') {
			setSearching(true);
			setSearchString(theInput);
			setTimeout(function () {
				setSearching(false);
			}, 3000);
		}
	};

	const _handleTypeInput = (e) => {
		setInputString(e.target.value);
	};

	const _handleSearchData = () => {
		setSearching(true);
		console.log(inputString);
		setSearchString(inputString);
		setTimeout(function () {
			setSearching(false);
		}, 3000);
	};

	const _handleEnterKeySearch = (e) => {
		const theInput = e.target.value;
		if (e.key === 'Enter') {
			setSearchString(theInput);
			setSearching(true);

			setTimeout(function () {
				setSearching(false);
			}, 3000);
		}
	};

	const _handleCatFilter = (selectedCat) => {
		setSearchingCat(true);
		if (selectedCat === 'All Categories') {
			setCategoryString('');
		} else {
			setCategoryString(selectedCat);
		}
		setTimeout(function () {
			setSearchingCat(false);
		}, 3000);
	};

	const _handleStatusFilter = (selectedStat) => {
		setSearchingStatus(true);
		if (selectedStat === 'All Statuses') {
			setStatusString('');
		} else {
			setStatusString(selectedStat);
		}
		setTimeout(function () {
			setSearchingStatus(false);
		}, 3000);
	};

	/** Author:Tanishq – to make it multi-cat sort */
	const _handleMultiStatusFilter = (selectedStatArray) => {
		console.log('selectedStatArray', selectedStatArray);
		setSearchingStatus(true);
		if (selectedStatArray.length === 0) {
			console.log('length is 0');
			setStatusString('');
			setStatusArray([]);
		} else {
			console.log('updating status array');
			setStatusArray(selectedStatArray);
		}
		setSearchingStatus(false);
	};

	const _handleRefreshData = () => {
		refreshData();
	};

	const _handleBackToQuote = () => {
		history.goBack();
	};

	// RENDERING FUNCTIONS -------------------------------------------
	const renderSearchIcon = () => {
		if (searching) {
			return <Button id={'spinningSearchingIcon'} renderIcon={CircleDash20} iconDescription="Search" hasIconOnly />;
		} else {
			return (
				<div className="bg-[#121E6C]">
					<Button renderIcon={Search20} iconDescription="Search" onClick={() => _handleSearchData()} hasIconOnly />
				</div>
			);
		}
	};

	const renderCatOverflowMenu = () => {
		if (searchingCat) {
			return <Button id={'spinningSearchingCatIcon'} renderIcon={CircleDash20} iconDescription="Searching.." hasIconOnly />;
		}
		let menuItemsCat = itemCategoriesNames.map((catName, i) => {
			let catNameClean = catName.split('-')[0];
			let itemStyle = {};

			if (categoryString === catNameClean) {
				itemStyle.background = '#cfd2e2';
			}
			if (catName.indexOf('-main') !== -1) {
				return (
					<OverflowMenuItem
						style={itemStyle}
						className={'mainCategoryBtn'}
						key={i}
						itemText={catNameClean}
						onClick={() => _handleCatFilter(catNameClean)}
					/>
				);
			}

			return <OverflowMenuItem style={itemStyle} key={i} itemText={catName} onClick={() => _handleCatFilter(catName)} />;
		});

		return (
			<OverflowMenu
				style={{ height: '3rem', maxHeight: '3rem', width: '3rem', background: '#f4f4f4' }}
				renderIcon={() => <Category20 />}
				className="bx--tooltip__trigger bx--tooltip--icon__top leftDropDownBtn"
				ariaLabel={'Category'}
			>
				<OverflowMenuItem
					style={categoryString === '' ? { background: '#cfd2e2' } : null}
					id="allCategoriesBtn"
					key={'all'}
					itemText={'ALL'}
					onClick={() => _handleCatFilter('All Categories')}
				/>
				{menuItemsCat}
			</OverflowMenu>
		);
	};

	const renderStatusOverflowMenu = () => {
		if (searchingStatus) {
			return <Button id={'spinningSearchingCatIcon'} renderIcon={CircleDash20} iconDescription="Searching.." hasIconOnly />;
		}
		let menuItemsStatus = itemStatusesNames.map((statusName, i) => {
			let itemStyle = {};
			if (statusString === statusName) {
				itemStyle.background = '#cfd2e2';
			}
			return <OverflowMenuItem style={itemStyle} key={i} itemText={statusName} onClick={() => _handleStatusFilter(statusName)} />;
		});
		return (
			<OverflowMenu
				style={{ height: '3rem', maxHeight: '3rem', width: '3rem', background: '#f4f4f4' }}
				renderIcon={() => <EventSchedule20 />}
				className="bx--tooltip__trigger bx--tooltip--icon__top leftDropDownBtn"
				ariaLabel={'Status'}
			>
				<OverflowMenuItem
					style={statusString === '' ? { background: '#cfd2e2' } : null}
					id="allStatusesBtn"
					key={'all'}
					itemText={'ALL'}
					onClick={() => _handleStatusFilter('All Statuses')}
				/>
				{menuItemsStatus}
			</OverflowMenu>
		);
	};

	const renderMultiSelectForStatus = () => {
		if (searchingStatus) {
			return <Button id={'spinningSearchingCatIcon'} renderIcon={CircleDash20} iconDescription="Searching.." hasIconOnly />;
		}

		console.log('INSIDE RENDER MULTI SELECT: ', statusArray);

		return (
			<div className="inline-flex items-center justify-center" style={{ height: '3rem', maxHeight: '3rem', width: '20rem', background: '#f4f4f4' }}>
				<ReactSelect
					className="w-full"
					placeholder="Select Status"
					options={statusOptions}
					isMulti
					isClearable={false}
					closeMenuOnSelect={false}
					hideSelectedOptions={false}
					components={{
						Option,
					}}
					onChange={(e) => _handleMultiStatusFilter(e)}
					allowSelectAll={true}
					value={statusArray}
				/>
			</div>
		);
	};

	//render the contents of the expanded row
	const renderExpandedRowContents = (row) => {
		const rowId = parseInt(row.id);
		const item = row;

		let imagesThumbs;
		if (row.expanded) {
			imagesThumbs = (
				<>
					<Button
						id="addImgButtonInv"
						renderIcon={Add20}
						kind="tertiary"
						size="small"
						onClick={() => history.push(`/image-management?upc=${row.upc}`)}
						iconDescription="Add Image"
						hasIconOnly
						tooltipAlignment={'end'}
						tooltipPosition="left"
					></Button>
					<div className="individualDataTableImgCont">
						<Zoom zoomMargin={40}>
							<Img
								src={[
									`https://cwc-product-images-s3-bucket.s3.amazonaws.com/product_images/${row.upc}.jpg`,
									`https://cwc-product-images-s3-bucket.s3.amazonaws.com/product_images/${row.upc}.png`,
									`https://cwc-product-images-s3-bucket.s3.amazonaws.com/product_images/${row.upc}`,
								]}
								width={40}
							/>
						</Zoom>
					</div>
					<div className="individualDataTableImgCont">
						<Zoom zoomMargin={40}>
							<Img
								src={[
									`https://cwc-product-images-s3-bucket.s3.amazonaws.com/product_images/${row.upc}-1.jpg`,
									`https://cwc-product-images-s3-bucket.s3.amazonaws.com/product_images/${row.upc}-1.png`,
									`https://cwc-product-images-s3-bucket.s3.amazonaws.com/product_images/${row.upc}-1`,
								]}
								width={40}
							/>
						</Zoom>
					</div>
				</>
			);
		}

		return (
			<div id="expRowContentContainer">
				<div id="expRowTop">
					<p>
						<span className={'boldEffect'}>Subcategory:</span> {item.itemPriceClass ? item.itemPriceClass : 'N/A'}
					</p>
					<p>
						<span className={'boldEffect'}>Warehouse:</span> {item.warehouse ? item.warehouse : 'N/A'}
					</p>
					<p>
						<span className={'boldEffect'}>Selling UM:</span> {item.sellUOM ? item.sellUOM : 'N/A'}
					</p>
					<p>
						<span className={'boldEffect'}>Packet Size:</span> {item.packSize ? item.packSize : 'N/A'}
					</p>
				</div>
				<div id="expRowBottom">
					<div style={{ marginTop: 20 }}>
						<p className={'boldEffect'}>Customer:</p>
						<p className={'boldEffect'}>Price:</p>
						<p className={'boldEffect'}>Date of Sale:</p>
					</div>

					<div>
						<p>{item.saleCust1 ? item.saleCust1 : 'N/A'}</p>
						<p>{item.salePrice1 ? item.salePrice1 : 'N/A'}</p>
						<p>{item.saleDate1 ? item.saleDate1 : 'N/A'}</p>
					</div>

					<div>
						<p>{item.saleCust2 ? item.saleCust2 : 'N/A'}</p>
						<p>{item.salePrice2 ? item.salePrice2 : 'N/A'}</p>
						<p>{item.saleDate2 ? item.saleDate2 : 'N/A'}</p>
					</div>

					<div>
						<p>{item.saleCust3 ? item.saleCust3 : 'N/A'}</p>
						<p>{item.salePrice3 ? item.salePrice3 : 'N/A'}</p>
						<p>{item.saleDate3 ? item.saleDate3 : 'N/A'}</p>
					</div>

					<div id="expContentImgContainer">{imagesThumbs}</div>
				</div>
			</div>
		);
	};

	const renderLastRightIcon = () => {
		if (addMode || editMode) {
			return <Button renderIcon={Redo20} iconDescription="Return To Quote" onClick={() => _handleBackToQuote()} hasIconOnly tooltipAlignment="end" />;
		} else {
			return (
				<div className="bg-[#121E6C]">
					<Button renderIcon={Renew20} iconDescription="Refresh" onClick={() => _handleRefreshData()} hasIconOnly tooltipAlignment="end" />
				</div>
			);
		}
	};

	//DATATABLE VARIABLES AND OBJECTS -------------------------------------
	let headers = [
		{
			id: 'itemNumber',
			title: 'Item #',
			sortCycle: 'tri-states-from-ascending',
		},
		{
			id: 'upc',
			title: 'UPC',
			sortCycle: 'tri-states-from-ascending',
		},
		{
			id: 'itemClass',
			title: 'Category',
			sortCycle: 'tri-states-from-ascending',
		},
		{
			id: 'description',
			title: 'Description',
			sortCycle: 'tri-states-from-ascending',
		},
		{
			id: 'expireDate',
			title: 'Expiration Date',
			sortCycle: 'tri-states-from-ascending',
		},
		{
			id: 'warehouse',
			title: 'WH Location',
			sortCycle: 'tri-states-from-ascending',
		},
		{
			id: 'estimatedShipDate',
			title: 'Est. Ship Date',
			sortCycle: 'tri-states-from-ascending',
		},
		{
			id: 'paidFor',
			title: 'Status',
			sortCycle: 'tri-states-from-ascending',
		},
		{
			id: 'fOBCost',
			title: 'FOB Cost',
			sortCycle: 'tri-states-from-ascending',
		},
		{
			id: 'units',
			title: 'Units',
			sortCycle: 'tri-states-from-ascending',
		},
	];

	let itemCategoriesNames = [`${inventoryData[0].itemClass}-main`];
	let itemStatusesNames = [];

	inventoryData.map((item, i) => {
		//set the categories
		if (itemCategoriesNames.indexOf(`${item.itemClass}-main`) === -1) {
			itemCategoriesNames.push(`${item.itemClass}-main`);
		}

		//set the subcategories
		if (item.itemPriceClass !== '' && itemCategoriesNames.indexOf(item.itemPriceClass) === -1) {
			itemCategoriesNames.push(`${item.itemPriceClass}`);
		}

		//set the statuses
		if (itemStatusesNames.indexOf(item.paidFor) === -1) {
			itemStatusesNames.push(item.paidFor);
		}
	});

	// console.log(itemCategories);
	// console.log(sortedRows, "<sortedrows len>");

	// render the datatable in its full splendor
	return (
		<div id="inventoryTableContainer">
			<div id="dataTableContainer">
				<div id="dataActionsContainer">
					{renderCatOverflowMenu()}
					{renderMultiSelectForStatus()}
					<Search
						id="theSearchBox"
						labelText={'inventory search'}
						onChange={(e) => _handleResetSearch(e)}
						onMouseLeave={(e) => _handleTypeInput(e)}
						onKeyPress={(e) => _handleEnterKeySearch(e)}
						id="inventorySearchBar"
						placeHolderText={'Search Inventory'}
						ref={textInputSearch}
					/>

					{renderSearchIcon()}
					{renderLastRightIcon()}
				</div>

				<TableToolbar>
					<TableBatchActions shouldShowBatchActions={hasBatchActions} totalSelected={selectedRowsCountInFiltered} onCancel={handleCancelSelection}>
						{addMode ? null : (
							<TableBatchAction
								id="download-action-button"
								renderIcon={Download20}
								iconDescription="Download the selected rows"
								onClick={() => _handleDownloadSelectedItems()}
							>
								Download
							</TableBatchAction>
						)}
						<TableBatchAction
							id="create-quote-action-button"
							renderIcon={addMode ? Add20 : RequestQuote20}
							iconDescription="Create a Quote"
							onClick={() => _handleCreateQuote()}
						>
							{addMode || editMode ? 'Add To Quote' : 'Create Quote'}
						</TableBatchAction>
					</TableBatchActions>
					<TableToolbarContent style={{ background: 'white' }}></TableToolbarContent>
				</TableToolbar>

				<Table isSortable>
					<TableHead>
						<TableRow>
							<TableExpandHeader />
							{hasSelection && (
								<TableSelectAll
									style={{ background: 'blu' }}
									className={'selectAllCheckbox'}
									id={`${elementId}--select-all`}
									checked={selectedAllInFiltered}
									indeterminate={selectedRowsCountInFiltered > 0 && !selectedAllInFiltered}
									ariaLabel="Select all rows"
									name={selectionAllName}
									onSelect={handleChangeSelectionAll}
								/>
							)}
							{headers.map(({ id: columnId, sortCycle, title }) => {
								const sortDirectionForThisCell = sortCycle && (columnId === sortColumnId ? sortDirection : 'NONE');
								return (
									<TableHeader
										key={columnId}
										isSortable={Boolean(sortCycle)}
										isSortHeader={sortCycle && columnId === sortColumnId}
										sortDirection={sortDirectionForThisCell}
										data-column-id={columnId}
										data-sort-cycle={sortCycle}
										data-sort-direction={sortDirectionForThisCell}
										onClick={handleChangeSort}
									>
										{title}
									</TableHeader>
								);
							})}
						</TableRow>
					</TableHead>
					<TableBody zebra={`true`}>
						{sortedRows.slice(start, start + pageSize).map((row) => {
							const { id: rowId, selected, expanded, hide } = row;
							const selectionName = !hasSelection ? undefined : `__custom-data-table_${elementId}_${rowId}`;

							if (hide) {
								return null;
							}

							return (
								<React.Fragment key={rowId}>
									<TableExpandRow
										ariaLabel={'The expandable item row'}
										key={rowId}
										style={hide ? { display: 'none' } : undefined}
										isSelected={hasSelection && selected}
										isExpanded={expanded}
										onExpand={(e) => handleChangeExpansion(e, expanded)}
										data-row-id={rowId}
									>
										{hasSelection && (
											<TableSelectRow
												id={`${elementId}--select-${rowId}`}
												checked={Boolean(selected)}
												name={selectionName}
												ariaLabel="Select row"
												onSelect={handleChangeSelection}
											/>
										)}
										{headers.map(({ id: columnId }) => (
											<TableCell key={columnId}>{row[columnId] ? row[columnId] : 'N/A'}</TableCell>
										))}
									</TableExpandRow>
									<TableExpandedRow colSpan={headers.length + 3} className="expanded-row-td">
										{renderExpandedRowContents(row)}
									</TableExpandedRow>
								</React.Fragment>
							);
						})}
					</TableBody>
				</Table>
			</div>
		</div>
	);
}

export default InventoryTable;
